import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import map from 'lodash/map';
import { getMapPosition } from './MapPosition';
import type { PersonaScores } from '../../data/Score';
import type { Persona } from '../../data/Personas';
import PointsOverlay from '../atoms/PointsOverlay';

export interface StateProps {
	personas: Persona[];
	lastPersonaScores: PersonaScores;
}

export interface DispatchProps {}

export interface OwnProps {
	/**
	 * Animation delay in seconds
	 */
	delay?: number;
}

type Props = StateProps & DispatchProps & OwnProps;

const ScoreMapLayer: FunctionComponent<Props> = (props: Props) => {
	const { delay = 2, personas, lastPersonaScores } = props;

	const pointsChangeComponents = useMemo(
		() =>
			map(personas, (persona, index) => {
				const score = lastPersonaScores[persona.name];
				const position = getMapPosition(index);
				return (
					<PointsOverlay
						key={persona.name + '_happiness_points_fixed'}
						points={score?.happiness}
						delay={delay}
						position="absolute"
						left={`calc(${position.x} + 5vmin)`}
						top={`calc(${position.y} - 8vmin)`}
					/>
				);
			}),
		[personas, lastPersonaScores, delay]
	);

	return <>{pointsChangeComponents}</>;
};

export default ScoreMapLayer;
